import qs from 'qs'

import { getRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { User } from '../../types/User'
import { userTransformer } from '../../transformers/userTransformer'
import { SUser } from '../../types/api/User'

const me = () =>
  getRestRequest({
    url:
      api.REST_API_URL +
      `/users/me?${qs.stringify(
        {
          populate: ['avatar', 'profile', 'speciality', 'role', 'alerts'],
        },
        {
          encodeValuesOnly: true,
        }
      )}`,
    transformer: (data: any): User => {
      const user = userTransformer(data as SUser)
      return {
        ...user,
        offersFeedbackIds: data.feedbacks?.reduce(
          (acc: any, next: any) => [...acc, next.offer.id],
          []
        ),
      }
    },
  })

export default me
